/**
 * API may return `w9_file` as an array or as a map (Angular keyvalue); normalize to a list of file rows.
 */
export function normalizeW9FileList(raw: unknown): Array<Record<string, unknown>> {
  if (raw == null) return []
  if (Array.isArray(raw)) return raw as Array<Record<string, unknown>>
  if (typeof raw === 'object') {
    return Object.values(raw as Record<string, Record<string, unknown>>).filter(
      (v) => v != null && typeof v === 'object'
    ) as Array<Record<string, unknown>>
  }
  return []
}

/** File id for download/delete — API uses `id` or `file_id`. */
export function getW9FileId(file: Record<string, unknown>): string {
  const id = file.file_id ?? file.id
  return id != null ? String(id) : ''
}

export function getW9FileName(file: Record<string, unknown>, index: number): string {
  return String(file.attachment_name ?? file.original_name ?? file.file_name ?? file.name ?? `W-9 file ${index + 1}`)
}
